import React, { useEffect, useState } from "react"; 
import CountUp from "react-countup";
import CommonService from "../../services/CommonService";

const AdminBalancePopup = ({ onClose }) => {
    const [show, setShow] = useState(false);
    const [balanceData, setBalanceData] = useState({
        totalWallet: 0,
        usedAmount: 0,
        availableBalance: 0,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const getBalanceColor = (balance) => {
        if (balance <= 0) return "text-danger";      
        if (balance > 0 && balance < 1000) return "text-warning"; 
        return "text-success";                        
    };

    const fetchBalance = async () => {
        try {
            setLoading(true);
            setError(null);
            var data = {
                "clientId":1
            };
            CommonService.getBallance(data)
            .then((response) => {
                const ballance = response.data?.data || {};
                setBalanceData({
                    totalWallet: ballance?.totalWallet,
                    usedAmount: ballance?.usedAmount,
                    availableBalance: ballance?.availableBalance,
                });
            })
            .catch((error) => {
                console.log("Error fetching product list:", error);
            });
            setLoading(false);
        } catch (err) {
            console.error(err);
            setError("Failed to fetch balance");
            setLoading(false);
        }
    };

    useEffect(() => {
        setTimeout(() => setShow(true), 50);
        fetchBalance();
    }, []);

    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ background: "rgba(0,0,0,0.4)", zIndex: 9999 }}
            onClick={onClose}
        >
            <div
                className={`position-absolute end-0 mt-5 me-4 p-4 text-white shadow-lg`}
                style={{
                    width: "380px",
                    background: "#0e4b77",
                    borderRadius: "16px",
                    transform: show ? "translateY(0)" : "translateY(-20px)",
                    opacity: show ? 1 : 0,
                    transition: "all 0.4s ease"
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column gap-3 mb-3">
                        {loading ? (
                            <div className="text-left">Loading...</div>
                        ) : error ? (
                            <div className="text-center text-danger">{error}</div>
                        ) : (
                            <>
                                <div className="text-left">
                                    <small className="opacity-75">Total Balance</small>
                                    <h3 className="fw-bold mb-0">
                                        <CountUp
                                            end={balanceData.totalWallet}
                                            separator=","
                                            decimals={2}
                                            prefix="₹ "
                                            duration={1.5}
                                        />
                                    </h3>
                                </div>

                                <div className="text-left">
                                    <small className="opacity-75">Total Used</small>
                                    <h3 className="fw-bold mb-0">
                                        <CountUp
                                            end={balanceData.usedAmount}
                                            separator=","
                                            decimals={2}
                                            prefix="₹ "
                                            duration={1.5}
                                        />
                                    </h3>
                                </div>

                                <div className="text-left">
                                    <small className="opacity-75">Available Balance</small>
                                    <h3 className={`fw-bold mb-0 ${getBalanceColor(balanceData.availableBalance)}`}>
                                        <CountUp
                                            end={balanceData.availableBalance}
                                            separator=","
                                            decimals={2}
                                            prefix="₹ "
                                            duration={1.5}
                                        />
                                    </h3>
                                </div>
                            </>
                        )}
                    </div>

                    <div>
                        {/* Refresh button now works */}
                        <i
                            className="ti ti-refresh me-2"
                            role="button"
                            onClick={fetchBalance}
                        ></i>
                        <i
                            className="ti ti-x"
                            role="button"
                            onClick={onClose}
                        ></i>
                    </div>
                </div>

                <div
                    className="mt-4 p-3"
                    style={{
                        border: "1px solid rgba(255,255,255,0.4)",
                        borderRadius: "12px",
                        background: "rgba(255,255,255,0.1)"
                    }}
                >
                    <div className="fw-semibold">
                        Wheels Analytics Infotech Private Limited
                    </div>
                    <small className="opacity-75">SBI BANK</small>

                    <div className="mt-3 small">
                        <div>AC: 43674948878</div>
                        <div>IFSC: SBIN0061708</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminBalancePopup;
